const reservations = [
  {
    bookingId: 'BK001',
    firstName: 'John',
    lastName: 'Doe',
    roomType: 'Deluxe (Rs.2000)',
    checkInDate: '2024-11-25',
    checkOutDate: '2024-11-28',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'No',
    email: 'john.doe@example.com',
    pickUpOption: 'Yes',
    location: 'Room 101',
    totalAmount: 'Rs. 2000',
    mobileNo: '9876543210',
    additionalNotes: 'Requested early check-in.',
  },
  {
    bookingId: 'BK002',
    firstName: 'Jane',
    lastName: 'Smith',
    roomType: 'Standard (Rs.1500)',
    checkInDate: '2024-11-26',
    checkOutDate: '2024-11-29',
    numOfRooms: 1,
    totalGuests: 1,
    smokingPreference: 'Yes',
    email: 'jane.smith@example.com',
    pickUpOption: 'No',
    location: 'Room 102',
    totalAmount: 'Rs. 1500',
    mobileNo: '9876543211',
    additionalNotes: 'No additional notes.',
  },
  {
    bookingId: 'BK003',
    firstName: 'Alice',
    lastName: 'Johnson',
    roomType: 'Suite (Rs.5000)',
    checkInDate: '2024-11-27',
    checkOutDate: '2024-11-30',
    numOfRooms: 2,
    totalGuests: 4,
    smokingPreference: 'No',
    email: 'alice.johnson@example.com',
    pickUpOption: 'Yes',
    location: 'Room 201',
    totalAmount: 'Rs. 10000',
    mobileNo: '9876543212',
    additionalNotes: 'Extra bedding requested.',
  },
  {
    bookingId: 'BK004',
    firstName: 'Bob',
    lastName: 'White',
    roomType: 'Deluxe (Rs.2000)',
    checkInDate: '2024-11-28',
    checkOutDate: '2024-11-30',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'No',
    email: 'bob.white@example.com',
    pickUpOption: 'No',
    location: 'Room 103',
    totalAmount: 'Rs. 4000',
    mobileNo: '9876543213',
    additionalNotes: 'Need extra towels.',
  },
  {
    bookingId: 'BK005',
    firstName: 'Charlie',
    lastName: 'Brown',
    roomType: 'Standard (Rs.1500)',
    checkInDate: '2024-11-29',
    checkOutDate: '2024-12-02',
    numOfRooms: 1,
    totalGuests: 1,
    smokingPreference: 'Yes',
    email: 'charlie.brown@example.com',
    pickUpOption: 'No',
    location: 'Room 104',
    totalAmount: 'Rs. 3000',
    mobileNo: '9876543214',
    additionalNotes: 'Requested late check-out.',
  },
  {
    bookingId: 'BK006',
    firstName: 'Daniel',
    lastName: 'Clark',
    roomType: 'Suite (Rs.5000)',
    checkInDate: '2024-11-30',
    checkOutDate: '2024-12-05',
    numOfRooms: 2,
    totalGuests: 4,
    smokingPreference: 'No',
    email: 'daniel.clark@example.com',
    pickUpOption: 'Yes',
    location: 'Room 202',
    totalAmount: 'Rs. 10000',
    mobileNo: '9876543215',
    additionalNotes: 'Celebration of anniversary.',
  },
  {
    bookingId: 'BK007',
    firstName: 'Emily',
    lastName: 'White',
    roomType: 'Deluxe (Rs.2000)',
    checkInDate: '2024-12-01',
    checkOutDate: '2024-12-04',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'Yes',
    email: 'emily.white@example.com',
    pickUpOption: 'No',
    location: 'Room 105',
    totalAmount: 'Rs. 4000',
    mobileNo: '9876543216',
    additionalNotes: 'Room near elevator.',
  },
  {
    bookingId: 'BK008',
    firstName: 'George',
    lastName: 'Miller',
    roomType: 'Standard (Rs.1500)',
    checkInDate: '2024-12-02',
    checkOutDate: '2024-12-06',
    numOfRooms: 1,
    totalGuests: 1,
    smokingPreference: 'No',
    email: 'george.miller@example.com',
    pickUpOption: 'No',
    location: 'Room 106',
    totalAmount: 'Rs. 3000',
    mobileNo: '9876543217',
    additionalNotes: 'Window view requested.',
  },
  {
    bookingId: 'BK009',
    firstName: 'Hannah',
    lastName: 'Green',
    roomType: 'Deluxe (Rs.2000)',
    checkInDate: '2024-12-05',
    checkOutDate: '2024-12-08',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'No',
    email: 'hannah.green@example.com',
    pickUpOption: 'Yes',
    location: 'Room 107',
    totalAmount: 'Rs. 4000',
    mobileNo: '9876543218',
    additionalNotes: 'Near swimming pool.',
  },
  {
    bookingId: 'BK010',
    firstName: 'Isabella',
    lastName: 'Jones',
    roomType: 'Suite (Rs.5000)',
    checkInDate: '2024-12-06',
    checkOutDate: '2024-12-09',
    numOfRooms: 2,
    totalGuests: 4,
    smokingPreference: 'No',
    email: 'isabella.jones@example.com',
    pickUpOption: 'No',
    location: 'Room 203',
    totalAmount: 'Rs. 10000',
    mobileNo: '9876543219',
    additionalNotes: 'Need extra bed.',
  },
  {
    bookingId: 'BK011',
    firstName: 'Amit',
    lastName: 'Sharma',
    roomType: 'Deluxe (Rs.4000)',
    checkInDate: '2024-12-07',
    checkOutDate: '2024-12-10',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'Yes',
    email: 'amit.sharma@example.com',
    pickUpOption: 'Yes',
    location: 'Room 101',
    totalAmount: 'Rs. 4000',
    mobileNo: '9876543220',
    additionalNotes: 'Require early check-in.',
  },
  {
    bookingId: 'BK012',
    firstName: 'Priya',
    lastName: 'Patel',
    roomType: 'Standard (Rs.2000)',
    checkInDate: '2024-12-08',
    checkOutDate: '2024-12-12',
    numOfRooms: 3,
    totalGuests: 6,
    smokingPreference: 'No',
    email: 'priya.patel@example.com',
    pickUpOption: 'No',
    location: 'Room 305',
    totalAmount: 'Rs. 6000',
    mobileNo: '9876543221',
    additionalNotes: 'Request for extra pillows.',
  },
  {
    bookingId: 'BK013',
    firstName: 'Rajesh',
    lastName: 'Kumar',
    roomType: 'Suite (Rs.5000)',
    checkInDate: '2024-12-09',
    checkOutDate: '2024-12-11',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'Yes',
    email: 'rajesh.kumar@example.com',
    pickUpOption: 'Yes',
    location: 'Room 404',
    totalAmount: 'Rs. 10000',
    mobileNo: '9876543222',
    additionalNotes: 'Prefer top floor room.',
  },
  {
    bookingId: 'BK014',
    firstName: 'Sita',
    lastName: 'Nair',
    roomType: 'Deluxe (Rs.4000)',
    checkInDate: '2024-12-10',
    checkOutDate: '2024-12-13',
    numOfRooms: 2,
    totalGuests: 4,
    smokingPreference: 'No',
    email: 'sita.nair@example.com',
    pickUpOption: 'No',
    location: 'Room 202',
    totalAmount: 'Rs. 8000',
    mobileNo: '9876543223',
    additionalNotes: 'Needs vegetarian food options.',
  },
  {
    bookingId: 'BK015',
    firstName: 'Vikram',
    lastName: 'Singh',
    roomType: 'Standard (Rs.2000)',
    checkInDate: '2024-12-11',
    checkOutDate: '2024-12-14',
    numOfRooms: 1,
    totalGuests: 2,
    smokingPreference: 'Yes',
    email: 'vikram.singh@example.com',
    pickUpOption: 'Yes',
    location: 'Room 305',
    totalAmount: 'Rs. 2000',
    mobileNo: '9876543224',
    additionalNotes: 'Require extra towels.',
  },
  {
    bookingId: 'BK016',
    firstName: 'Ananya',
    lastName: 'Reddy',
    roomType: 'Suite (Rs.5000)',
    checkInDate: '2024-12-12',
    checkOutDate: '2024-12-14',
    numOfRooms: 2,
    totalGuests: 4,
    smokingPreference: 'No',
    email: 'ananya.reddy@example.com',
    pickUpOption: 'No',
    location: 'Room 109',
    totalAmount: 'Rs. 10000',
    mobileNo: '9876543225',
    additionalNotes: 'Need room with a view.',
  },
];

export default reservations;
